// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__36VGS","cell":"ColumnAccessor_cell__3VVza","firstCellAccent":"ColumnAccessor_firstCellAccent__3_A0P"};